import http from '@/shared/api/http'

export function getMe() {
  return http.get('/users/me')
}

export function getPermissions() {
  return http.get('/users/me/permissions')
}

export function updateUser(data) {
  return http.patch('/users/me', data)
}